import { BaseModel } from './base-model';


export abstract class BackGroundOptimizationModelBase extends BaseModel
{
   
}

let BackGroundOptimizationModel: BackGroundOptimizationModelBase|null = null;

function setBackGroundOptimizationModel(model: BackGroundOptimizationModelBase)
{
    BackGroundOptimizationModel = model;
}

export { BackGroundOptimizationModel, setBackGroundOptimizationModel };
